import { parse } from "date-fns";
import { fullDateLongFormat } from "@common/helpers/date";
import {
    AccrualImporterGroup,
    AccrualImporterLineItem,
} from "./useAccrualImporterState";

function parseDate(value: string): Date | undefined;
function parseDate(value: string, fallback: null): Date | null;
function parseDate(value: string, fallback?: null): Date | null | undefined {
    if (!value) {
        return fallback === null ? null : undefined;
    }
    return parse(value, fullDateLongFormat, new Date());
}

interface MappedAccrualItem {
    /**
     * Bill / invoice id when this group should patch an existing record;
     * undefined for newly created groups.
     */
    id?: string;
    entityId: number;
    invoiceNumber: string | null;
    counterpartyId: string | null;
    description: null;
    due: Date | null;
    createdAt: Date | undefined;
    currency: string;
    status?: string;
    tax?: number;
    lines: MappedAccrualLineItem[];
}

interface MappedAccrualLineItem {
    /** Existing line-item id; undefined for newly added lines. */
    id?: string;
    productOrService: string | null;
    catalogItemId: string | null;
    catalogItemPriceId: string | null;
    description: string | null;
    amount: number;
    quantityDecimal: number | null;
    unitAmount: number | null;
    classIds: string[] | undefined;
    accountId: string | null;
    accrualAccountId: string | null;
}

export function mapGroupToAccrualItem(
    group: AccrualImporterGroup,
): MappedAccrualItem {
    return {
        id: group.accrualId,
        entityId: group.entityId!,
        invoiceNumber: group.invoiceNumber || null,
        counterpartyId: group.counterpartyId ?? null,
        description: null,
        due: parseDate(group.dueDate, null),
        createdAt: parseDate(group.createdDate),
        currency: "usd",
        status: group.status,
        tax: group.tax,
        lines: group.lines.map((line) => mapLineItem(line)),
    };
}

function mapLineItem(line: AccrualImporterLineItem): MappedAccrualLineItem {
    return {
        id: line.lineId,
        productOrService: line.productOrService,
        catalogItemId: line.catalogItemId,
        catalogItemPriceId: line.catalogItemPriceId,
        description: line.description || null,
        amount: line.amount,
        quantityDecimal: line.quantityDecimal,
        unitAmount: line.unitAmount,
        classIds: line.classIds ?? undefined,
        accountId: line.accountId,
        accrualAccountId: line.accrualAccountId,
    };
}
